export default __webpack_public_path__ + "static/char-s-36-zh-Hans-a3e82991563e49ebc90f24710b30c528.png";